import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { useECommerceProduct } from "@/components/Product/ECommerce/hooks/useECommerceProduct.hook";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

const NoDelivery = () => {
    const { t } = useGranite();
    const { visibilityType, hasDelivery } = useECommerceProduct();

    if (hasDelivery) {
        return null;
    }

    return (
        <div className={cn("tw:flex tw:mt-2")}>
            <Button
                size="lg"
                outline={true}
                color="primary"
                fullWidth={true}
                className={cn("tw:pointer-events-none")}
                disabled
            >
                {t(`ecommerce.text.${visibilityType}`)}
            </Button>
        </div>
    );
};

export { NoDelivery };
